import { constant } from 'lodash/fp';

import { createReducer } from '@mews/framework/redux';
import { CLEAR_ERROR, LOG_ERROR } from './actionTypes';

const initialState = {};

export const error = createReducer(initialState, {
    // @ts-expect-error $TSFixMeError: Parameter '_state' implicitly has an 'any' type.
    [LOG_ERROR]: (_state, { message, key }: $TSFixMe) => ({
        message,
        key,
    }),
    [CLEAR_ERROR]: constant(initialState),
});
